import {
  getModuleById,
  getModuleProgress,
  getLessonsById,
  getLessonProgress,
  getLessonProgressById,
} from "@/api/api";
import store from "@/store";
import {
  LessonsStepDefinition,
  PracticeStepDefinition,
  stepTypes,
} from "@/components/Lessons/Lesson/stepsDefinition";

export async function resumeProgressFromStoredPayload(router, progress, studentEmail) {
  const { data: moduleResponse } = await getModuleById(progress.module);
  const progressResponse = await getModuleProgress({
    module__uuid: moduleResponse.uuid,
    student__email: studentEmail,
  });
  const moduleProgress = progressResponse.data.results[0];
  if (!moduleProgress) {
    window.location.assign("/app/modules");
    return;
  }

  const { data: lessonResponse } = await getLessonsById(progress.lesson);
  const lessonProgress = await getLessonProgress({
    student__email: studentEmail,
    lesson__uuid: lessonResponse.uuid,
  });
  const firstLp = lessonProgress.data.results[0];
  if (!firstLp) {
    window.location.assign("/app/modules");
    return;
  }
  const { data: lessonProgressByUuid } = await getLessonProgressById(firstLp.uuid);

  store.commit("modules/selectedModule", moduleResponse);
  store.commit("progress/module", moduleProgress);

  store.commit("modules/currentLesson", lessonResponse);
  store.commit("progress/lesson", lessonProgressByUuid);

  await store.dispatch("lesson/teacher_lesson", lessonResponse.teacher_lesson);
  await store.dispatch("lesson/practice", lessonResponse.practice);
  await store.dispatch("lesson/grammar", lessonResponse.grammar);

  const stepDefinition = stepTypes.find((step) => step.value === progress.step_type);
  if (!stepDefinition) {
    await router.push({ name: "lesson-view" });
    return;
  }

  let index = 1;
  let route = { name: "lesson-view" };

  switch (stepDefinition.key) {
    case "TEACH_INTRO":
      await router.push({ name: "introduction" });
      return;
    case "GRAMMAR_EXERCISE":
      await router.push({
        name: "exercise",
        params: { index: String(progress.step_number) },
      });
      return;
    default:
      switch (stepDefinition.section) {
        case "TEACHER_LESSON":
          index = LessonsStepDefinition.indexOf(stepDefinition.key);
          route = {
            name: "guided-lesson",
          };
          if (stepDefinition.key === "Speaking") {
            route.query = { sn: progress.step_number };
          } else if (stepDefinition.key === "Grammar") {
            if (progress.step_number >= 0) {
              route.query = { gn: progress.step_number };
            }
          } else if (stepDefinition.key === "Homework") {
            route.query = { hn: progress.step_number };
          }
          break;
        case "PRACTICE":
          index = PracticeStepDefinition.indexOf(stepDefinition.key);
          route = {
            name: "practice",
          };
          if (stepDefinition.key === "Speaking") {
            route.query = { sn: progress.step_number };
          } else if (stepDefinition.key === "Homework") {
            route.query = { hn: progress.step_number };
          }
          break;
        default:
          break;
      }
      store.commit("lesson/step", index);
      await router.push(route);
  }
}
